import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Container, Heading, Paragraph, Button } from '@scentregroup/ui'
import CardList from '../card-list'
import TabsHeader from '../tabs/tabs-header'
import { fromMovie } from '../card-list/card'
import containerStyle from '../container.scss'
import { SEE_MORE_MOVIES_TEXT, MIN_MOVIES_TO_SHOW } from '../../constants'
import style from './index.scss'

class FilteredCardList extends Component {
  state = {
    activeTab: 0,
    minItems: MIN_MOVIES_TO_SHOW,
  }

  switchTabs = e => {
    this.setState({
      activeTab: parseInt(e.target.getAttribute('index'), 10),
      minItems: null,
    })
  }

  selectAllTab = () => {
    this.setState({
      activeTab: this.props.tabHeadings
        .map(heading => heading.displayDate)
        .indexOf('All'),
    })
  }

  getCardsForList() {
    const { tabHeadings, entries: movies, centreSlug } = this.props
    const { activeTab } = this.state
    const activeTabDate = tabHeadings[activeTab].date
    return movies
      .filter(
        movie =>
          activeTabDate === 'All' || movie.sessions.includes(activeTabDate)
      )
      .map(fromMovie(centreSlug, activeTabDate !== 'All' && activeTabDate))
  }

  render() {
    const { tabHeadings, title } = this.props
    const numberOfTabs = tabHeadings.length
    const selectedTab = Math.min(numberOfTabs, this.state.activeTab)
    const headings = [...tabHeadings].splice(0, numberOfTabs)
    const unsuccessfulText =
      "We haven't confirmed movies for that day yet. How about trying another day?"

    const cardsForList = this.getCardsForList()

    return (
      <Container type="large" className={containerStyle.container}>
        <div className={style.headings}>
          <Heading type="large">{title}</Heading>
          <TabsHeader
            headings={headings.map(tabHeading => tabHeading.displayDate)}
            selectedTab={selectedTab}
            onTabHeadingClick={this.switchTabs}
          />
        </div>
        {cardsForList.length > 0 ? (
          <CardList
            cards={cardsForList}
            buttonText={SEE_MORE_MOVIES_TEXT}
            minItems={this.state.minItems}
          />
        ) : (
          <div className={style.unsuccessful}>
            <Paragraph type="large" className={style.unsuccessfulText}>
              {unsuccessfulText}
            </Paragraph>
            <Button
              type="primary"
              className={style.seeAllButton}
              onClick={this.selectAllTab}
            >
              {SEE_MORE_MOVIES_TEXT}
            </Button>
          </div>
        )}
      </Container>
    )
  }
}

FilteredCardList.propTypes = {
  entries: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      genre: PropTypes.string,
      classification: PropTypes.string,
      sessions: PropTypes.array,
    })
  ).isRequired,
  centreSlug: PropTypes.string,
  tabHeadings: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
}

export default FilteredCardList
